import Vue from 'vue';
import { HTTP } from '@/utils/http';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

const defaultCommitment = {
  agreed: false,
};

export default {
  actions: {
    async [actionTypes.DO_CREATE_COMMITMENT]({ commit }, payload) {
      const { data } = await HTTP.post('/commitments', payload);
      commit(mutationTypes.SET_COMMITMENT, data.data.commitments[0]);
      return data;
    },
  },
  getters: {
    [getterTypes.GET_COMMITMENT]: state => state.commitment,
    [getterTypes.GET_COMMITMENTS]: state => state.commitments,
  },
  mutations: {
    [mutationTypes.SET_COMMITMENT](state, payload) {
      state.commitment = payload;
    },
    [mutationTypes.SET_COMMITMENT_FIELD](state, payload) {
      const nodes = payload.key.split('.');
      let obj = state.commitment;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, payload.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutationTypes.SET_COMMITMENTS](state, payload) {
      state.commitments = payload;
    },
  },
  state: {
    commitment: _.cloneDeep(defaultCommitment),
    commitments: [],
  },
};
